import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

import { PairIconSkeleton } from '../../pair-icon-skeleton'

import { PairListItemRoot } from './pair-list-item'
import { PairMarketCapacitySkeleton } from './pair-list-item-market-cap'

type Props = {}

export const PairListItemSkeleton: React.FC<Props> = () => {
  return (
    <PairListItemRoot>
      <IconContainer>
        <PairIconSkeleton size={32} quoteSize={14} />
      </IconContainer>
      <Main>
        <MainTop>
          <MainStart>
            <Skeleton width={60} height={16} paddingBlock={2} />
            <Skeleton width={20} height={16} paddingBlock={2} />
          </MainStart>
          <MainEnd>
            <Price>
              <Skeleton width={70} height={16} paddingBlock={2} />
            </Price>
          </MainEnd>
        </MainTop>
        <MainBottom>
          <div>
            <Skeleton width={60} height={12} paddingBlock={2} />
            <Skeleton width={40} height={8} paddingBlock={1} />
          </div>
          <Skeleton width={40} height={20} paddingBlock={4} />
        </MainBottom>
      </Main>

      <MarketCapContainer>
        <PairMarketCapacitySkeleton />
      </MarketCapContainer>
    </PairListItemRoot>
  )
}

const Main = styled.div`
  display: grid;
  padding-inline-end: 6px;
`

const MainTop = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`
const MainStart = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  gap: 4px;
`
const MainEnd = styled.div`
  display: grid;
  justify-self: end;
`

const MainBottom = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
`

const IconContainer = styled.div`
  display: grid;
  padding-inline-end: 6px;
`

const MarketCapContainer = styled.div`
  padding-inline: 6px 0;
  padding-block: 2px 2px;
  border-inline-start: 1px solid var(--background-4);
`

const Price = styled.div``
